module.exports = __webpack_public_path__ + "assets/img/modal-avatar-2e58615f.png";